module.exports = __webpack_public_path__ + "img/gzh.016d140a.jpg";